<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :readonly="isView"
        >
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="标题" prop="title">
                        <Input
                            v-model="info.title"
                            :maxlength="20"
                            placeholder="最多20个字符"
                            :disabled="loading"
                        >
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="层级" prop="orgLevel">
                        <Select
                            v-model="info.orgLevel"
                            transfer
                            clearable
                            placeholder
                            :disabled="loading"
                        >
                            <Option
                                v-for="(item, index) in orgLevelList"
                                :value="item.id"
                                :key="index"
                            >
                                {{ item.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="发布状态" prop="publishStatus">
                        <i-switch
                            v-model="info.publishStatus"
                            true-value="1"
                            false-value="0"
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import Dict from '_u/dict'
import Enum from '_u/enum'
import mForm from '_v/common/m-form'
// 接口

import { numAdd, numView, numUpdate } from './demo'

export default {
    name: 'demo-form',
    mixins: [mForm],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            info: {
                id: this.id,
                title: '', // 标题
                publishStatus: '2', // 是否发布
                orgLevel: '', // 层级
                ver: '', // 版本号
            },
            dict: {
                orgLevel: Dict.NULL, // 发布状态
            },
        }
    },
    computed: {
        ruleValidate() {
            var rules = {
                title: [{ required: true, message: '标题必填' }],
                orgLevel: [{ required: true, message: '层级必填' }],
            }
            return rules
        },
        orgLevelList() {
            return this.dict.orgLevel.toList()
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return numView(this.id)
            } else {
                return Promise.resolve(null)
            }
        },
    },
    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: 'default', text: '关闭', name: 'cancel' }]

        // 按钮
        if (this.isView === false) {
            btns.unshift({ type: 'primary', text: '确定', name: 'confirm' })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([Dict.get(['org_level']), this.fetch()])
                .then((args) => {
                    var [dictGroup, view] = args
                    // 词典
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    // 表单
                    if (view) {
                        var viewData = view.data.entity
                        if (viewData) {
                            Object.keys(this.info).forEach(
                                (name) => (this.info[name] = viewData[name])
                            )
                        }
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = this.info
                    if (this.id) {
                        return numUpdate(formData)
                    } else {
                        return numAdd(formData)
                    }
                })
                .then(() => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
